export const MAX_ZOOM_RATIO = 3.0;
export const MIN_ZOOM_RATIO = 0.0;
